import axios from "axios";
import React, { useState } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import "../../sass/shortcode/Signinup.scss";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../helpers/api";

export default function ForgotPassword() {
  pageTitle("Forgot Password");

  const [email, setEmail]         = useState("");
  const [loading, setLoading]     = useState(false);
  const [message, setMessage]     = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const res = await axios.post(
        `${BASE_URL}/auth/forgot-password`,
        { email },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success) {
        setSubmitted(true);
      } else {
        setMessage({ type: "error", text: res.data.message || "Something went wrong." });
      }
    } catch (err) {
      setMessage({ type: "error", text: "Failed to send reset email. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        title="Forgot Password?"
        subTitle="Reset your password securely"
      />

      <div className="signin-container">
        <div className="signin-wrapper">
          <div className="signin-left">
            <img
              src="/images/auth-img.png"
              alt="Forgot Password"
              className="signin-image"
            />
          </div>

          <div className="signin-form">
            {submitted ? (
              // ✅ Success Screen
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <div style={{ fontSize: "60px", marginBottom: "16px" }}>📧</div>
                <h2 className="signin-title">Check Your Email!</h2>
                <p className="signin-subtitle" style={{ marginBottom: "24px" }}>
                  We've sent a password reset link to <strong>{email}</strong>.
                  <br />The link will expire in <strong>10 minutes</strong>.
                </p>
                <p style={{ fontSize: "14px", color: "#888" }}>
                  Didn't receive it? Check your spam folder or{" "}
                  <span
                    style={{ color: "#0a6cff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => { setSubmitted(false); setMessage(null); }}
                  >
                    try again
                  </span>
                </p>
                <div className="signup-link" style={{ marginTop: "24px" }}>
                  <Link to="/signIn">← Back to Sign In</Link>
                </div>
              </div>
            ) : (
              <>
                <h2 className="signin-title">Forgot Password</h2>
                <p className="signin-subtitle">
                  Enter your registered email and we'll send you a reset link
                </p>

                {message && (
                  <div style={{
                    padding: "10px 14px",
                    borderRadius: "6px",
                    marginBottom: "16px",
                    fontSize: "14px",
                    backgroundColor: message.type === "error" ? "#fff0f0" : "#f0fff4",
                    color: message.type === "error" ? "#cc0000" : "#1a7a3c",
                    border: `1px solid ${message.type === "error" ? "#ffcccc" : "#b2f0c8"}`,
                  }}>
                    {message.type === "error" ? "❌ " : "✅ "}{message.text}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      className="form-input"
                      placeholder="Enter your registered email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>

                  <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? "Sending..." : "Send Reset Link"}
                  </button>
                </form>

                <div className="signup-link" style={{ marginTop: "16px" }}>
                  <Link to="/signIn">← Back to Sign In</Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}